import * as React from "react";
import type { SVGProps } from "react";
const SvgCopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="copy_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M469.333 85.333a128 128 0 0 0-128 128v128h-128a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128h341.334a128 128 0 0 0 128-128v-128h128a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H469.333zm341.334 512H469.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h341.334a42.667 42.667 0 0 1 42.666 42.666v341.334a42.667 42.667 0 0 1-42.666 42.666zM341.333 426.667v128a128 128 0 0 0 128 128h128v128a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V469.333a42.667 42.667 0 0 1 42.666-42.666h128z"
    />
  </svg>
);
export default SvgCopyIcon;
